module.exports = __webpack_public_path__ + "static/media/Kanel-min.74b16e86.PNG";